import React from "react";
import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Checkbox,
  Grid,
  FormHelperText,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import icon from "../../Components/assets/Images/iconnew.svg";
import trash from "../../Components/assets/Images/trash.png";
import edit from "../../Components/assets/Images/edit.png";
import calenderImage from "../../Components/assets/Images/calendar.svg";

interface Props {
  index: number;
  onEditClick: any;
  onDeleteClick: any;
  percentageofShare: number;
  currentIndex: any;
  nominees: any;
}
export default function NomineeBar({
  index,
  onEditClick,
  onDeleteClick,
  percentageofShare,
  currentIndex,
  nominees,
}: Props) {
  return (
    <>
      {nominees.length > 1 ? (
        <div className={Styles.headerTitle}>
          <p className={Styles.nomineeText}>
            {index + 1}
            {index + 1 === 1
              ? "st"
              : index + 1 === 2
              ? "nd"
              : "rd"} Nominee{" "}
            {percentageofShare ? `| ${percentageofShare}%` : ""}
          </p>
          <div>
            <IconButton
              disabled={index === 0}
              style={{
                visibility: index === 0 ? "hidden" : "visible",
              }}
              onClick={() => {
                onDeleteClick();
              }}
              id="nomineesDeleteNomineeButton"
            >
              <img src={trash} style={{ width: "20px" }} />
            </IconButton>
            {index === currentIndex ? (
              ""
            ) : (
              <IconButton
                onClick={() => {
                  onEditClick(index);
                }}
                sx={{ marginLeft: "20px" }}
              >
                <img src={edit} style={{ width: "20px" }} />
              </IconButton>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
